import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-217b102c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-group-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -wide -top-and-bottom" }
const _hoisted_3 = { class: "season-group-detail-content" }
const _hoisted_4 = { class: "season-group-header" }
const _hoisted_5 = {
  key: 0,
  class: "season-group-nav"
}
const _hoisted_6 = { class: "season-group-body" }
const _hoisted_7 = { class: "season-group-side-block" }
const _hoisted_8 = { class: "entry-team-block" }
const _hoisted_9 = {
  class: "global-search-input",
  onsubmit: "return false;",
  action: "/"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-search icon" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "entry-team-list"
}
const _hoisted_12 = ["data-is-active", "disabled", "onClick"]
const _hoisted_13 = {
  key: 0,
  class: "global-empty-text"
}
const _hoisted_14 = {
  key: 1,
  class: "global-empty-text"
}
const _hoisted_15 = { class: "season-group-main-block" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = { class: "button-block" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "ブロックに追加", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle-icon -right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-right icon" })
], -1))
const _hoisted_21 = {
  key: 1,
  class: "global-loading -small"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "交換", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "exchange-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "uil uil-exchange icon" })
], -1))
const _hoisted_25 = {
  key: 1,
  class: "global-loading -small"
}
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle-icon -left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "uil uil-arrow-left icon" })
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "ブロックから離脱", -1))
const _hoisted_29 = {
  key: 1,
  class: "global-loading -small"
}
const _hoisted_30 = { class: "selected-block" }
const _hoisted_31 = { class: "heading" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = ["data-is-active", "onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "global-icon-button -draggable" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "uil uil-draggabledots icon" })
], -1))
const _hoisted_35 = ["onUpdate:modelValue", "onChange"]
const _hoisted_36 = { class: "name" }
const _hoisted_37 = {
  key: 1,
  class: "global-empty-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.groups.list.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.list, (group) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "item",
                    key: group.id
                  }, [
                    _createVNode(_component_router_link, {
                      to: {
                  name: 'seasonGroupDetail',
                  params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, group_id: group.id }
                },
                      class: "link",
                      "data-is-active": group.id === Number(_ctx.$route.params.group_id)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(group.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "data-is-active"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("form", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "input",
                  placeholder: "チームを検索",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.keyword) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchForm.keyword]
                ])
              ]),
              (_ctx.entries.list.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries.list, (entry) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: entry.id,
                        class: "item"
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "button",
                          "data-is-active": _ctx.grouping.in_team_id === entry.id,
                          disabled: entry.isBelonged,
                          onClick: ($event: any) => (_ctx.selectInTeam(entry.id))
                        }, _toDisplayString(entry.team_name) + " " + _toDisplayString(entry.division), 9, _hoisted_12)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.isSearching)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_13, "該当するエントリーチームがありません"))
                      : (_openBlock(), _createElementBlock("p", _hoisted_14, "エントリーしているチームがありません"))
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  type: "button",
                  class: "operation-button",
                  disabled: _ctx.isOnlyInTeamSelected || _ctx.isLoadingGrouping.inTeam,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.divideTeam('in')))
                }, [
                  (!_ctx.isLoadingGrouping.inTeam)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_19,
                        _hoisted_20
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_21))
                ], 8, _hoisted_18),
                _createElementVNode("button", {
                  type: "button",
                  class: "operation-button",
                  disabled: _ctx.isInAndOutTeamSelected || _ctx.isLoadingGrouping.exchangeTeams,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.divideTeam('exchange')))
                }, [
                  (!_ctx.isLoadingGrouping.exchangeTeams)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_23,
                        _hoisted_24
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25))
                ], 8, _hoisted_22),
                _createElementVNode("button", {
                  type: "button",
                  class: "operation-button",
                  disabled: _ctx.isOnlyOutTeamSelected || _ctx.isLoadingGrouping.outTeam,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.divideTeam('out')))
                }, [
                  (!_ctx.isLoadingGrouping.outTeam)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_27,
                        _hoisted_28
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29))
                ], 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.group.data?.name), 1),
                (_ctx.group.teams.length > 0)
                  ? (_openBlock(), _createBlock(_component_draggable, {
                      key: 0,
                      tag: "ul",
                      class: "selected-team-list",
                      list: _ctx.group.teams,
                      handle: ".global-icon-button.-draggable",
                      "item-key": "id",
                      onUpdate: _ctx.updateTeamPriority
                    }, {
                      item: _withCtx(({element}) => [
                        _createElementVNode("li", _hoisted_32, [
                          _createElementVNode("a", {
                            href: "",
                            class: "selected-team-list-card",
                            "data-is-active": _ctx.grouping.out_team_id === element.entry_team_id,
                            onClick: _withModifiers(($event: any) => (_ctx.selectOutTeam(element.entry_team_id)), ["prevent"])
                          }, [
                            _hoisted_34,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "global-input",
                              "onUpdate:modelValue": ($event: any) => ((element.allocate_code) = $event),
                              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"])),
                              onChange: ($event: any) => (_ctx.updateAllocateCode(element.entry_team_id, element.allocate_code))
                            }, null, 40, _hoisted_35), [
                              [_vModelText, element.allocate_code]
                            ]),
                            _createElementVNode("p", _hoisted_36, _toDisplayString(element.team_name) + " " + _toDisplayString(element.division), 1)
                          ], 8, _hoisted_33)
                        ])
                      ]),
                      _: 1
                    }, 8, ["list", "onUpdate"]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_37, "エントリーチームをブロックに追加してください"))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}